import { SyntheticEvent } from 'react'

import { AutocompleteOption, ModalType, ObjectShortDTO } from '@types'

import {
  AvailableVariables,
  GanttActionType,
  GanttColumnForm,
  ModelType,
} from '@gantt/components/GanttCreateOrEdit'
import { GanttParametersForm } from '@gantt/components/GanttCreateOrEdit/components/GanttConfiguration/components/GeneralForm/components/GanttParametersForm'

import { DefaultSortForm } from '../DefaultSortForm'
import { GeneralForm } from '../GeneralForm'
import { ResourceForm } from '../ResourceForm'
import { TimelineFormArray } from '../TimelineFormArray'

type GanttConfigFormsRenderProps = {
  isDisabledResource: boolean
  isLoading: boolean
  isShowDialog: boolean
  activeStep: number
  currentTabResource: number
  modelType: ModelType
  rowsColumnTable: GanttColumnForm[]
  rowsActionTableResource: GanttActionType[]
  objects: ObjectShortDTO[] | undefined
  filteredObjects: ObjectShortDTO[] | undefined
  onTabChangeResource: (event: SyntheticEvent<Element, Event>, newValue: number) => void
  onDeleteColumn: (id: string | number) => void
  onDeleteActionResource: (id: string | number) => void
  onEdit: (
    row: GanttColumnForm | GanttActionType | null,
    id?: string | number | undefined,
    isAction?: boolean | undefined
  ) => void
  onHide: (row: GanttColumnForm, checked: boolean) => void
  onOpenDialog: (props: {
    type: ModalType
    id?: number | string
    row?: GanttColumnForm | GanttActionType | null
    barIndex?: number | null
    selectedBarObject?: AutocompleteOption<string> | null
    inputAvailableVariables?: AvailableVariables
    existingPaths?: string[]
    selectedPaths?: string[]
  }) => void
  usedObjectsList: string[]
}

export const GanttConfigFormsRender = ({
  isDisabledResource,
  isLoading,
  isShowDialog,
  activeStep = 0,
  objects,
  filteredObjects,
  modelType,
  rowsActionTableResource,
  rowsColumnTable,
  currentTabResource,
  onTabChangeResource,
  onDeleteColumn,
  onOpenDialog,
  onEdit,
  onHide,
  onDeleteActionResource,
  usedObjectsList,
}: GanttConfigFormsRenderProps) => {
  switch (activeStep) {
    case 0:
      return <GeneralForm isLoading={isLoading} modelType={modelType} objects={objects} />
    case 1:
      return (
        <ResourceForm
          currentTabResource={currentTabResource}
          filteredObjects={filteredObjects}
          isDisabled={isDisabledResource}
          isLoadingObjects={isLoading}
          isShowDialog={isShowDialog}
          objects={objects}
          rowsActionTable={rowsActionTableResource}
          rowsColumnTable={rowsColumnTable}
          usedObjectsList={usedObjectsList}
          onDeleteColumn={onDeleteColumn}
          onEdit={onEdit}
          onHide={onHide}
          onOpenDialog={onOpenDialog}
          onSetActionToDeleteResource={onDeleteActionResource}
          onTabChangeResource={onTabChangeResource}
        />
      )
    case 2:
      return (
        <TimelineFormArray
          filteredObjects={filteredObjects}
          isLoadingObjects={isLoading}
          objects={objects}
          usedObjectsList={usedObjectsList}
        />
      )
    case 3:
      return <DefaultSortForm />
    case 4:
      return <GanttParametersForm />
    default:
      return null
  }
}
